import * as React from "react";
import PrimaryButton, {PrimaryButtonProps} from 'components/partials/buttons/primary-button';
import { IntroHeadlineProps } from "types/intro-headline-props";

const IntroHeadline: React.FC<IntroHeadlineProps> = ({ headline = 'Example Headline', buttonProps }) => {
    return (
        <div className="intro-headline">
            <div className="intro-headline__main">
                <h2 className="h3 title">{headline}</h2>
            </div>
            {buttonProps && (
                <div className="intro-headline__side">
                    <PrimaryButton {...buttonProps} />
                </div>
            )}
        </div>
    );
}

export default IntroHeadline;